var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Partially_Paid",
  "data-name": "Partially Paid",
  width: 16,
  height: 16,
  viewBox: "0 0 16 16"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  id: "Partially_Paid_Background",
  cx: 8,
  cy: 8,
  r: 8
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "Rupee_Icon",
  d: "M.768-4.582q.275.018.571.018a3.79,3.79,0,0,0,.58-.044,2.6,2.6,0,0,0,.542-.144,1.581,1.581,0,0,0,.463-.275,1.378,1.378,0,0,0,.337-.442,1.827,1.827,0,0,0,.167-.642H.516a1.937,1.937,0,0,1,.1-.173l.167-.278q.105-.17.234-.369H3.281a.456.456,0,0,0-.146-.308,1.61,1.61,0,0,0-.354-.278,2.551,2.551,0,0,0-.425-.2A1.093,1.093,0,0,0,2-7.8H.516a1.376,1.376,0,0,1,.1-.211Q.7-8.15.785-8.288L.94-8.531a.666.666,0,0,1,.073-.105H5.895l-.032.064q-.032.064-.085.155l-.117.2-.12.2q-.056.094-.094.155L5.408-7.8H4.125a3.76,3.76,0,0,1,.214.425,1.523,1.523,0,0,1,.114.442H5.895l-.486.82h-.9A2.332,2.332,0,0,1,4.2-5.18a2.265,2.265,0,0,1-.58.642,2.649,2.649,0,0,1-.765.393,4.489,4.489,0,0,1-.867.19.145.145,0,0,0,.021.038q.021.032.05.073a1.2,1.2,0,0,0,.07.1l2.6,3.592v.146H3.615L.768-3.809Z",
  transform: "translate(4.484 12.637)",
  fill: "#fff"
})));
export default __webpack_public_path__ + "static/media/payment_status_icon.3072cf7f.svg";
export { SvgComponent as ReactComponent };